<template>
    <!-- S: 생성하기 메인 -->
    <v-tab-item :value="TABS.FINISH.value" class="fill-height">
        <v-layout column justify-center fill-height>
            <div class="scroll-primary" style="flex: 1 1 auto; overflow-y: auto">
                <v-sheet class="pa-40 pa-lg-60">
                    <div class="text-center">
                        <h3 class="tit mb-8 mb-lg-16">송부 완료</h3>
                        <p class="page-text--lg grey-6--text">
                            총 {{ applications?.length?.format?.() || 0 }}건의 계약서가 송부 되었습니다. <br />
                            근로자 현황에서 확인 가능합니다.
                        </p>
                    </div>
                    <div class="v-btn-group">
                        <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('exit')"><span class="grey-6--text">확인</span></v-btn>
                        <texting-dialog v-bind="textingProps">
                            <template #activator="{ attrs, on }">
                                <v-btn v-bind="attrs" v-on="on" color="primary" class="min-w-140px min-w-lg-160px">
                                    <span>문자발송</span>
                                </v-btn>
                            </template>
                        </texting-dialog>
                    </div>
                </v-sheet>
            </div>
        </v-layout>
    </v-tab-item>
    <!-- E: 생성하기 메인 -->
</template>

<script>
import { TABS } from "../lib";

import TextingDialog from "@/components/dashboard/company/texting/texting-dialog.vue";

export default {
    components: {
        TextingDialog,
    },
    props: {
        applications: { type: Array, defatul: () => [] },
    },
    data: () => ({
        TABS,
    }),
    computed: {
        textingProps() {
            let { applications } = this;
            return { value: applications, applications };
        },
    },
};
</script>

<style></style>
